/**
 * @see https://github.com/umdjs/umd/blob/master/templates/returnExports.js
 * @see https://github.com/web-auth/webauthn-framework/tree/26e361b03cab50d417cbbb78f1aeed342d5bf714/doc/webauthn
 */

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(root.jQuery);
    }
}(typeof self !== 'undefined' ? self : this, function ($) {

    function bufferToBase64(buf) {
        var binstr = Array.prototype.map.call(buf, function (ch) {
            return String.fromCharCode(ch);
        }).join('');
        return btoa(binstr);
    }

    function bufferToBase64url(bytes) {
        let binary = '';
        for (const b of bytes) binary += String.fromCharCode(b);
        return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    }

    function base64UrlDecode(input) {
        input = input
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        const pad = input.length % 4;
        if (pad) {
            if (pad === 1) {
                throw new Error('InvalidLengthError: Input base64url string is the wrong length to determine padding');
            }
            input += new Array(5-pad).join('=');
        }

        return window.atob(input);
    };

    function arrayToBase64String(a) {
        return btoa(String.fromCharCode(...a));
    }

    function parsePublicKey(publicKey) {
        publicKey.challenge = Uint8Array.from(
            base64UrlDecode(publicKey.challenge),
            c => c.charCodeAt(0)
        );

        if (publicKey.allowCredentials) {
            publicKey.allowCredentials = publicKey.allowCredentials.map(function(data) {
                return {
                    ...data,
                    'id': Uint8Array.from(
                        base64UrlDecode(data.id),
                        c => c.charCodeAt(0)
                    )
                };
            });
        }

        if (publicKey.user) {
            publicKey.user.id = Uint8Array.from(
                (publicKey.user.id),
                c => c.charCodeAt(0)
            );
        }

        if (publicKey.excludeCredentials) {
            publicKey.excludeCredentials = publicKey.excludeCredentials.map(function(data) {
                return {
                    ...data,
                    'id': Uint8Array.from(
                        base64UrlDecode(data.id),
                        c => c.charCodeAt(0)
                    )
                };
            });
        }

        return publicKey;
    }

    let Webauthn = {
        parameter: {
            checkCredentialsOptions: '/webauthn/check',
            checkCredentials: '/webauthn/check',
            createCredentialsOptions: '/webauthn/create',
            verifyCredentials: '/webauthn/verify',
            createCredentials: '/webauthn/create',
            deleteCredentials: '/webauthn/delete',
        },

        checkCredentials: function(onSuccess, onError) {
            $.getJSON(Webauthn.parameter.checkCredentialsOptions, function(publicKey) {
                let pk = parsePublicKey(publicKey);
                Webauthn.showHint();
                navigator.credentials.get({publicKey: pk})
                    .then(function (data) {
                        console.log(data);

                        let publicKeyCredential = {
                            id: data.id,
                            type: data.type,
                            rawId: bufferToBase64url(new Uint8Array(data.rawId)),
                            response: {
                                authenticatorData: bufferToBase64url(new Uint8Array(data.response.authenticatorData)),
                                clientDataJSON: bufferToBase64url(new Uint8Array(data.response.clientDataJSON)),
                                signature: bufferToBase64url(new Uint8Array(data.response.signature)),
                                userHandle: data.response.userHandle ? bufferToBase64url(new Uint8Array(data.response.userHandle)) : null
                            }
                        };

                        console.log(publicKeyCredential);

                        $.post(Webauthn.parameter.checkCredentials, {data: btoa(JSON.stringify(publicKeyCredential))})
                            .done(function(data) {
                                if (data.status == 'OK') {
                                    Webauthn.hideHint();
                                    onSuccess();
                                }
                            });
                    }, error => {
                        if (onError) {
                            onError(error);
                        }
                    });
            });
        },

        createCredentials: function(onSuccess, onError) {
            $.getJSON(Webauthn.parameter.createCredentialsOptions, function(publicKey) {
                let pk = parsePublicKey(publicKey);
                Webauthn.showHint();
                navigator.credentials.create({publicKey: pk})
                    .then(function (data) {
                        let publicKeyCredential = {
                            id: data.id,
                            type: data.type,
                            rawId: bufferToBase64url(new Uint8Array(data.rawId)),
                            response: {
                                clientDataJSON: bufferToBase64url(new Uint8Array(data.response.clientDataJSON)),
                                attestationObject: bufferToBase64url(new Uint8Array(data.response.attestationObject))
                            }
                        };

                        Webauthn.verifyCredentials(onSuccess, onError, publicKeyCredential);
                    }, function (error) {
                        if (onError) {
                            onError(error);
                        }
                    });
            });
        },

        verifyCredentials: function(onSuccess, onError, publicKeyCredential) {
            $.post(Webauthn.parameter.verifyCredentials, {credential: btoa(JSON.stringify(publicKeyCredential))})
                .done(function(data) {
                    if (data.status == 'OK') {
                        Webauthn.saveCredentials(onSuccess, onError, publicKeyCredential, data.cn);
                    }
                });
        },

        saveCredentials: function(onSuccess, onError, publicKeyCredential, cn) {
            let $modal = $('<div class="modal" tabindex="-1" role="dialog" id="credential-modal" />').append(
                $('<div class="modal-dialog" />').append(
                    $('<div class="modal-content" role="document" />').append(
                        $('<div class="modal-header" />').append(
                            $('<h5 class="modal-title">Sicherheitsschlüssel erkannt</h5>')
                        ).append(
                            $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>')
                        )
                    ).append(
                        $('<div class="modal-body" />').append(
                            $('<form>').append(
                                $('<input type="hidden" id="credential-data" name="credential-data" />').val(btoa(JSON.stringify(publicKeyCredential)))
                            ).append(
                                $('<div class="form-group" />').append(
                                    $('<label for="credential-name" class="col-form-label">Name:</label>')
                                ).append(
                                    $('<input type="text" class="form-control" id="credential-name" name="credential-name" />').val(cn)
                                )
                            )
                        )
                    ).append(
                        $('<div class="modal-footer" />').append(
                            $('<button type="button" class="btn btn-secondary" data-dismiss="modal">Abbrechen</button>')
                        ).append(
                            $('<button type="button" class="btn btn-primary" id="btn-add-key">Schlüssel hinzufügen</button>').click(function() {
                                $.post(Webauthn.parameter.createCredentials, $('#credential-modal').find('form').serialize())
                                    .done(function(data) {
                                        if (data.status == 'OK') {
                                            onSuccess();
                                        }
                                    });
                            })
                        )
                    )
                )
            );

            Webauthn.hideHint();
            $modal.modal('show');
        },

        showHint: function() {
            if ($('#webauthn-hint').length == 0) {
                let $modalHint = $('<div class="modal" tabindex="-1" role="dialog" id="webauthn-hint" />').append(
                    $('<div class="modal-dialog" />').append(
                        $('<div class="modal-content" role="document" />').append(
                            $('<div class="modal-header" />').append(
                                $('<h5 class="modal-title">Sicherheitsschlüssel</h5>')
                            ).append(
                                $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>')
                            )
                        ).append(
                            $('<div class="modal-body" />').append(
                                $('<span>Bitte Interagieren Sie mit ihrem Schlüssel</span>')
                            )
                        ).append(
                            $('<div class="modal-footer" />').append(
                                $('<button type="button" class="btn btn-secondary" data-dismiss="modal">Abbrechen</button>')
                            )
                        )
                    )
                );
                $modalHint.modal('show');
            } else {
                $('#webauthn-hint').modal('show');
            }
        },

        hideHint: function() {
            if ($('#webauthn-hint').length > 0) {
                $('#webauthn-hint').modal('hide');
            }
        },

        delete: function (credentialId, onSuccess, onError) {
            $.post(Webauthn.parameter.deleteCredentials, {credentialId: credentialId})
                .done(function (data) {
                    if (data.status == 'OK') {
                        onSuccess();
                    } else {
                        onError();
                    }
                });
        },

    };

    return Webauthn;
}));
